import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DisplayAndSelectModel } from '@bo-client/shared/components/display-and-selec-option/display-and-select.model';
import { DisplayAndSelectService } from '@bo-client/shared/components/display-and-selec-option/display-and-select.service';

@Component({
  selector: 'app-select-option-modal',
  templateUrl: './select-option-modal.component.html',
  styleUrls: ['./select-option-modal.component.scss']
})
export class SelectOptionModalComponent implements OnInit {
  constructor(
    public displayAndSelectService: DisplayAndSelectService,
    public dialogRef: MatDialogRef<SelectOptionModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public inputData: { selectedItem: DisplayAndSelectModel; title: string }
  ) {}

  ngOnInit(): void {}

  selectItem() {
    this.dialogRef.close({
      resultOk: true
    });
  }

  cancelModal() {
    this.dialogRef.close({
      resultOk: false
    });
  }
}
